import { AfterViewInit, Component, inject, input, OnInit, signal } from '@angular/core';
import { NotOverridableSponsorBannerKeys } from 'src/app/_constants';
import { NotOverridableSponsorBannerKeysType, Sponsor } from 'src/app/_interfaces';
import { AdsService, AnalyticsService, RouteParserService, VideoAdsService } from 'src/app/_services';

@Component({
    selector: 'app-sponsor-banner-signal',
    imports: [],
    templateUrl: './sponsor-banner-signal.component.html',
    styleUrl: './sponsor-banner-signal.component.scss'
})
export class SponsorBannerSignalComponent implements OnInit, AfterViewInit {
    sponsor_key = input<string>('');
    entry_sponsor = input<Sponsor | undefined>(undefined);
    aspect_ratio = input<string>('16:9');
    location = input<string>('');

    sponsor = signal<Sponsor | null>(null);

    private adAPI = inject(AdsService);
    private videoAdAPI = inject(VideoAdsService);
    private analyticsService = inject(AnalyticsService);
    private routeParser = inject(RouteParserService);

    async ngOnInit() {
        if (Object.keys(this?.entry_sponsor() || {})?.length) {
            this.sponsor.set(this.entry_sponsor()!);
            return;
        }

        this.videoAdAPI.videoAdSponsor.subscribe((sponsor) => sponsor && this.overrideSponsorBanner(sponsor!));

        this.overrideSponsorBanner(this.videoAdAPI.get__videoAd()?.[0]?.sponsor);
    }

    ngAfterViewInit(): void {
        setTimeout(() => this.postBannerEvent(), 100);
    }

    postEvent(): void {
        if (this.sponsor() && this.sponsor_key) {
            const should_override: boolean = this.videoAdAPI.get__videoAd()?.[0]?.sponsor?.id ? true : false;
            const key: string = should_override ? `${this.sponsor_key()}-overridden` : this.sponsor_key();
            this.analyticsService.postEvent(key, {});
        }
        this.postBannerEvent(`Sponsor banner tapped`);
        this.openLink();
    }

    overrideSponsorBanner(sponsor: Sponsor): void {
        this.sponsor.set(this.adAPI.getSponsor(this.sponsor_key()));

        if (this.sponsor() && sponsor?.id && !NotOverridableSponsorBannerKeys.includes(this.sponsor_key() as NotOverridableSponsorBannerKeysType)) {
            this.sponsor.set(sponsor);
        }
    }

    postBannerEvent(event: string = `Sponsor banner visible`) {
        const sponsor_location = this.sponsor()?.key === `homescreen-rotation` ? `Home` : this.sponsor()?.key;

        if (this.sponsor()) {
            const payload = {
                key: this.sponsor()?.key,
                event,
                sponsor_id: this.sponsor()?.id,
                sponsor_name: this.sponsor()?.name,
                sponsor_location,
                sponsor_campaign_id: this.sponsor()?.sponsor_campaign_id
            };
            this.analyticsService.postEvent(`sponsor`, payload)?.then(() => {
                // this.sponsor = this.adAPI.getSponsor(this.sponsor_key)
            });
        }
    }

    openLink() {
        const url = this.sponsor()?.url.includes('https://') ? this.sponsor()?.url : `https://${this.sponsor()?.url}`;
        if (url?.includes('bleachr://iap')) {
            this.routeParser.parseBleachrRoutes('bleachr://iap');
            return;
        }
        window.open(this.forceHttps(this.sponsor()?.url), '_blank');
    }

    forceHttps(url: string | undefined): string {
        if (!url) {
            return '';
        }
        const protocolRegex = /^[a-zA-Z]+[^a-zA-Z0-9]+/;

        if (protocolRegex.test(url)) {
            return url.replace(protocolRegex, 'https://');
        }

        if (!url.startsWith('https://')) {
            return 'https://' + url;
        }

        return url;
    }

    get imageSrc() {
        return this.sponsor() ? this.sponsor()?.image_url : '';
    }

    get imageAspectRatio() {
        return this.aspect_ratio().replace(':', '/');
    }
}
